export const equipmentAv = [
  {
    name: 'equipment_av_info',
    value: '',
    type: 'textarea',
    placeholder: 'INFO',
    className: 'mt-2'
  }
];
